import {Category} from "../ValueObjects";
import {Tag} from "../../../components/tag manager/value objects";

export interface ArticleSearchResultJson {
	articleId:number
	placeholders:StringMap<string>
	categoryIds:string[]
	tags:Tag[]
}

export class ArticleSearchResult {

	articleId:number
	placeholders:StringMap<string>
	categories:Category[]
	tags:Tag[]

	constructor(object:ArticleSearchResultJson, allCategories:Category[]) {
		this.articleId    = object.articleId
		this.placeholders = object.placeholders
		this.tags         = object.tags
		this.categories   = allCategories.filter(function(cat) {
			return object.categoryIds.indexOf(cat.getId()) != -1
		});
	}

	static fromObjects(objects:ArticleSearchResultJson[], allCategories:Category[]):ArticleSearchResult[] {
		return objects.map(function(obj) {
			return new ArticleSearchResult(obj, allCategories)
		});
	}
}



// WEBPACK FOOTER //
// ./src/news2/advancedSearch/results/ValueObjects.ts